import React, { useCallback, useEffect, useState } from "react";
// componentes
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
  Spinner,
} from "reactstrap";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import Pagination from "../../../components/Paginationv3";
import SearchFilters from "../../../components/SearchFilters";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import WaitExport from "../../../components/WaitExport";
// rotas
import { useLocation } from "react-router-dom";
// redux
import { useSelector } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// hooks
import useDebounce from "../../../utils/hooks/useDebounce";
// services
import {
  deleteAll,
  getSurveysByGroup,
  getAllSurveys,
} from "../../../utils/services/survey";
import { getQuotasConvention } from "../../../utils/services/quotas";
// relatórios
import { createXlsx } from "./createXlsx";
import { quizVibraXlsx } from "./reports/quizvibraXlsx";
import { quotasLogsXlsx } from "./reports/logsQuotasXlsx";
import { quotasSelectedsXlsx } from "./reports/selectedsQuotasXlsx";
import { quotasSupporterXlsx } from "./reports/supporterQuotasXlsx";

export default function ReportSurvey(props) {
  const { token: jwt, theme } = useSelector(
    (state) => state.global_user_data.data,
  );

  const location = useLocation();
  const idEvent = location.state.idEvent;
  //state de busca e paginação
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [activeFilter, setActiveFilter] = useState("name");

  //state de collapses
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [collapseIsOpenQuiz, setCollapseIsOpenQuiz] = useState(false);

  //state de dados da tabela
  const [surveys, setSurveys] = useState([]);

  //state de exportação
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  //state de botões/relatórios condicionais por tema
  const [visibleBtnPackLovers, setVisibleBtnPackLovers] = useState(false);
  const [visibleBtnAxe, setVisibleBtnAxe] = useState(false);
  const [btnsAvailable, setBtnsAvailable] = useState([]);
  const [totalItemsQuotasLogs, setTotalItemsQuotasLogs] = useState(0);
  const [totalItemsQuotasSelecteds, setTotalItemsQuotasSelecteds] = useState(0);
  const [totalItemsQuotaSsupporter, setTotalItemsQuotaSsupporter] = useState(0);

  //state de exclusão de todas as respostas
  const [confirmAllDisabled, setConfirmAllDisabled] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [successDlg, setSuccessDlg] = useState(false);
  const [errorOnDeleteAll, setErrorOnDeleteAll] = useState(false);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  // loading
  const [loading, setLoading] = useState(false);

  const columnsFilter = [
    { name: "Participante", value: "name", type: "text" },
    { name: "Pergunta", value: "question", type: "text" },
    { name: "Reposta", value: "answer", type: "text" },
    { name: "Acertou", value: "hit", type: "boolean" },
    { name: "Data", value: "data", type: "date" },
  ];

  const debouncedSearch = useDebounce(search, 300);

  // altera o filtro de busca ativo e limpa o texto pesquisado
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // inverte uma data no formato dd/mm/aaaa para aaaa-mm-dd
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // formata o texto de busca conforme o tipo do filtro ativo
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // formata data e hora para exibição na tabela
  const formatDate = (date) => {
    const dateFormat = date.split("T")[0].split("-").reverse().join("/");
    const time = date.split("T")[1].slice(0, 8);

    return `${dateFormat}  ${time}`;
  };

  // busca a listagem de respostas
  const getAll = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAllSurveys({
        jwt,
        eventId: idEvent,
        offset: currentPage,
        limit: itemsPerPage,
        search: treatmentSearch(),
        columnSearch: activeFilter,
      });

      if (response?.data?.findAllSurveyData) {
        setSurveys(response.data.findAllSurveyData.data || []);
        setTotalItems(response.data.findAllSurveyData.count);
      } else {
        toast.error("Erro ao buscar respostas.");
      }
    } catch (error) {
      console.error("Erro ao buscar respostas:", error);
      toast.error("Erro ao buscar respostas.");
    } finally {
      setLoading(false);
    }
  }, [jwt, idEvent, currentPage, itemsPerPage, debouncedSearch, activeFilter]);

  // verifica quais relatórios condicionais têm dados disponíveis
  function getBtnsVisible() {
    ["vemDeVibra"].forEach((item) => {
      checkRegs(item).then((el) => {
        if (el) {
          setBtnsAvailable((prev) => [...prev, item]);
        }
      });
    });
  }

  // verifica se existem respostas agrupadas para o relatório informado
  async function checkRegs(reportName) {
    const res = await getSurveysByGroup({
      jwt,
      eventId: idEvent,
      offset: 1,
      limit: 10,
      search,
      reportName,
    });
    return res?.data?.findAllSurveyData?.count > 0;
  }

  // verifica, por tema/evento, quais botões de relatório exibir
  async function getVisibleButtons() {
    try {
      if (
        theme[0]?.id === "8029badb-d64c-4af8-9f52-59b60e346767" &&
        (idEvent === "88b23836-4a06-4ea1-b6a9-1ba52ce61b9b" ||
          idEvent === "c1b1e0cf-a169-4b19-b200-479c96fb5cfd")
      ) {
        setVisibleBtnPackLovers(true);

        const logsRes = await getQuotasConvention(jwt, 1, 10, "logs");
        setTotalItemsQuotasLogs(logsRes.count);

        const selectedsRes = await getQuotasConvention(
          jwt,
          1,
          10,
          "cotasadquiridas",
        );
        setTotalItemsQuotasSelecteds(selectedsRes.count);

        const supporterRes = await getQuotasConvention(
          jwt,
          1,
          10,
          "apoiadorazul",
        );
        setTotalItemsQuotaSsupporter(supporterRes.count);
      }

      if (
        theme[0]?.id === "e75977b6-f31b-4813-8732-02651d1febf9" &&
        idEvent === "0846aa49-7195-4296-867a-eec863269a13"
      ) {
        setVisibleBtnAxe(true);
      }
    } catch (error) {
      console.error("Erro ao buscar dados de cotas:", error);
      toast.error("Erro ao buscar dados de cotas.");
    }
  }

  // deleta todas as respostas do evento
  async function confirmDeleteAll() {
    setLoadingDelete(true);
    try {
      const response = await deleteAll(idEvent);
      if (response.message === "deleted") {
        setDynamicTitle("Deletadas");
        setDynamicDescription("Respostas deletadas");
        setErrorOnDeleteAll(false);
      } else {
        setDynamicTitle("Erro");
        setDynamicDescription("Ocorreu um erro ao deletar as Respostas");
        setErrorOnDeleteAll(true);
      }
    } catch (error) {
      console.error("Erro ao deletar respostas:", error);
      setDynamicTitle("Erro");
      setDynamicDescription("Ocorreu um erro ao deletar as Respostas");
      setErrorOnDeleteAll(true);
    } finally {
      setLoadingDelete(false);
      setConfirmAllDisabled(false);
      setSuccessDlg(true);
      getAll();
    }
  }
  useEffect(() => {
    getAll();
    getVisibleButtons();
    getBtnsVisible();
  }, [getAll]);

  return (
    <div>
      <WaitExport
        isOpen={exportInProgress}
        name="Relatório de Respostas"
        preposicao="do"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      {successDlg ? (
        <SweetAlert
          success={!errorOnDeleteAll}
          error={errorOnDeleteAll}
          title={dynamicTitle}
          onConfirm={() => {
            setSuccessDlg(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <>
            <p>{dynamicDescription}</p>
          </>
        </SweetAlert>
      ) : null}
      {confirmAllDisabled ? (
        <SweetAlert
          title={`Deseja remover todas as Respostas?`}
          warning
          showCancel={!loadingDelete}
          showConfirm={!loadingDelete}
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDeleteAll();
          }}
          onCancel={() => setConfirmAllDisabled(false)}
        >
          {loadingDelete && (
            <>
              <Spinner
                style={{ color: "gray", marginBottom: "5px" }}
                animation="border"
                size="lg"
              />
              <p>Limpando Respostas...</p>
            </>
          )}
        </SweetAlert>
      ) : null}
      <Card>
        <CardBody>
          <CardTitle>Relatórios de Respostas</CardTitle>
          {visibleBtnPackLovers && (
            <div>
              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "150px",
                }}
              >
                <SectionComponent
                  sectionName="Relatórios Itaú"
                  setIsOpen={setCollapseIsOpenQuiz}
                  isOpen={collapseIsOpenQuiz}
                />
              </Row>
              <Collapse isOpen={collapseIsOpenQuiz}>
                {totalItemsQuotasLogs ? (
                  <Button
                    color="success"
                    className="btn-rounded waves-effect waves-light reports-button-add"
                    onClick={() => {
                      quotasLogsXlsx({
                        jwt,
                        offset: 1,
                        limit: 9999,
                        totalItems: totalItemsQuotasLogs,
                        setFinishExport,
                        type: "logs",
                      });
                      setExportInProgress(true);
                    }}
                  >
                    Exportar Ações
                  </Button>
                ) : null}

                {totalItemsQuotasSelecteds ? (
                  <Button
                    color="success"
                    className="btn-rounded waves-effect waves-light reports-button-add"
                    onClick={() => {
                      quotasSelectedsXlsx({
                        jwt,
                        offset: 1,
                        limit: 9999,
                        totalItems: totalItemsQuotasSelecteds,
                        setFinishExport,
                        type: "cotasadquiridas",
                      });
                      setExportInProgress(true);
                    }}
                  >
                    Exportar Cotas Selecionadas
                  </Button>
                ) : null}

                {totalItemsQuotaSsupporter ? (
                  <Button
                    color="success"
                    className="btn-rounded waves-effect waves-light reports-button-add"
                    onClick={() => {
                      quotasSupporterXlsx({
                        jwt,
                        offset: 1,
                        limit: 9999,
                        totalItems: totalItemsQuotaSsupporter,
                        setFinishExport,
                        type: "apoiadorazul",
                      });
                      setExportInProgress(true);
                    }}
                  >
                    Exportar Cotas Apoiador
                  </Button>
                ) : null}
              </Collapse>
            </div>
          )}
          {visibleBtnAxe && (
            <div>
              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "150px",
                }}
              >
                <SectionComponent
                  sectionName="Relatórios"
                  setIsOpen={setCollapseIsOpenQuiz}
                  isOpen={collapseIsOpenQuiz}
                />
              </Row>
              <Collapse isOpen={collapseIsOpenQuiz}>
                {btnsAvailable.includes("vemDeVibra") && (
                  <Button
                    color="success"
                    className="btn-rounded waves-effect waves-light reports-button-add"
                    onClick={() => {
                      quizVibraXlsx({
                        jwt,
                        eventId: idEvent,
                        limit: 500,
                        search: search,
                        totalItems,
                        setFinishExport,
                      });
                      setExportInProgress(true);
                    }}
                  >
                    Carbono Zero
                  </Button>
                )}
              </Collapse>
            </div>
          )}
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={activeFilter === "data" ? "date" : "text"}
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={activeFilter === "data" ? "date" : "text"}
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                {surveys.length > 0 && (
                  <Row className="mobile-btns-top" style={{ marginTop: 10 }}>
                    <div
                      onClick={() => {
                        createXlsx({
                          jwt,
                          eventId: idEvent,
                          limit: 500,
                          search: search,
                          totalItems,
                          setFinishExport,
                        });
                        setExportInProgress(true);
                      }}
                    >
                      Exportar Relatório
                    </div>
                  </Row>
                )}
              </Collapse>
            </div>
            <div className="header-btns-container">
              {surveys.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() => {
                    createXlsx({
                      jwt,
                      eventId: idEvent,
                      limit: 500,
                      search: search,
                      totalItems,
                      setFinishExport,
                    });
                    setExportInProgress(true);
                  }}
                >
                  Exportar Relatório
                </Button>
              )}
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nome do Participante</th>
                  <th>Pergunta</th>
                  <th>Resposta</th>
                  <th>Acertou</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={5} />
                ) : (
                  surveys.map((e) => (
                    <tr key={`${e.loginId}-${e.question}-${e.createdAt}`}>
                      <td>{e.loginName}</td>
                      <td>{e.question}</td>
                      <td>{e.answer}</td>
                      <td>{e.hit ? "Sim" : "Não"}</td>
                      <td>{formatDate(e.createdAt)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            surveys?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {surveys?.length > 0 && (
          <ActionButtonRounded
            onClick={() => setConfirmAllDisabled(true)}
            title="Limpar Todas Respostas"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
            className="btn-rounded waves-effect waves-light events-button-add-lg"
          />
        )}
        <Pagination
          data={surveys}
          search={search}
          currentIndex={currentPage}
          setCurrentIndex={setCurrentPage}
          countData={totalItems}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}
